import React from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  Box,
  useTheme
} from '@mui/material';
import { GitHub as GitHubIcon } from '@mui/icons-material';
import { motion } from 'framer-motion';

const Header = () => {
  const theme = useTheme();

  return (
    <AppBar 
      position="static" 
      elevation={0}
      sx={{ 
        backgroundColor: 'transparent',
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Toolbar>
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Box>
            <Typography 
              variant="h6" 
              component="div" 
              sx={{ 
                fontWeight: 700,
                background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Webtoon Translator
            </Typography>
            <Typography 
              variant="caption" 
              component="div" 
              sx={{ 
                opacity: 0.7,
                fontSize: '0.7rem',
                lineHeight: 1,
              }}
            >
              AI-Powered Translation
            </Typography>
          </Box>
        </motion.div>
        
        <Box sx={{ flexGrow: 1 }} />
        
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Button
            color="inherit"
            startIcon={<GitHubIcon />}
            href="https://github.com/cphanhth/Webtoon-Translator"
            target="_blank"
            rel="noopener noreferrer"
          >
            GitHub
          </Button>
        </motion.div>
      </Toolbar>
    </AppBar>
  );
};

export default Header; 